<section>
    <xm-tablet-segment-five *ngIf="showPlanSixTabletSection" [planData]="planData" [currentLine]="currentLine">
        <div class="shared-data-cta" >
            <button id="switch-unlimited-plan" class="xm-btn-secondary-light promise-btn" [promiseBtn]="planEligibilityPromise"
                (promiseClick)="openModal()" [ngClass]="{'disabled': isLLEEnabledMemberOrViewer}" [disabled]="isLLEEnabledMemberOrViewer"><span>{{ switchToCbmLevel5TabletCta }}</span></button>
            <span class="error" *ngIf="planEligibilityFail">{{ errorText }}</span>
        </div>
    </xm-tablet-segment-five>
    <div *ngIf="!showPlanSixTabletSection" class="info">
        <div class="info-icon">
            <xm-media-image aria-hidden="true" [imageOptions]="miniIcon"></xm-media-image>
        </div>
        <div class="data">
            <h4 class="plan-name">{{ planName }}</h4>
            <span class="plan-price">{{ planPrice }}</span>
            <p class="plan-subheader" *ngIf="activePlan">{{ planData.planDescription }}</p>
            <p class="plan-subheader" *ngIf="!activePlan">{{ planData.notActivePlanDescription }}</p>
        </div>
        <div class="badge" *ngIf="lineSummary.isStandaloneWatch">
            <div *ngIf="activePlan" class="action" role="status" [attr.aria-label]="planName + ' is ' + inUse">
                <xm-media-image [imageOptions]="inUseIcon" class="use-icon" center="auto" size="auto"></xm-media-image>
                <span class="action-text">{{ inUse }}</span>
            </div>
        </div>
        <div *ngIf="!lineSummary.isStandaloneWatch">
            <div *ngIf="activePlan" class="action" role="status" [attr.aria-label]="planName + ' is ' + inUse">
                <xm-media-image [imageOptions]="inUseIcon" class="use-icon" center="auto" size="auto"></xm-media-image>
                <span class="action-text">{{ inUse }}</span>
            </div>
            <div *ngIf="!activePlan && !(lineSummary.isScheduledSwitch && !isUnlScheduledSwitch())" class="btn-action">
                <button class="xm-btn-secondary-light promise-btn" [ngClass]="{'disabled': isLLEEnabledMemberOrViewer}" [disabled]="isLLEEnabledMemberOrViewer" [promiseBtn]="planEligibilityPromise"
                    (promiseClick)="openModal()"><span>{{ switchPlanLabel }}</span></button>
                <span class="error" *ngIf="planEligibilityFail">{{ errorText }}</span>
            </div>
        </div>
    </div>

    <div class="features" *ngIf="(shouldAccountShowPromotion || linePromotion?.length || tradeInDDAPromo?.length || extendedPromoDollar?.length) && !showPlanSixTabletSection"> 
        <div class="active-plan-feature">
            <div class="features-content">
                <xm-media-image aria-hidden="true" [imageOptions]="promotionIcon" class="promotion-icon"></xm-media-image>
                <div class="promotion">
                    <div *ngIf="shouldAccountShowPromotion">
                        <xm-promotions *ngFor="let promo of accountPromotion" [header]="servicePromotions.promoAccountHeader" [subheader]="promoAccountSubheader(promo)" [imageOptions]="promotionIcon" class="promo-content">
                        </xm-promotions>
                    </div>
                    <div *ngIf="linePromotion?.length">
                        <xm-promotions *ngFor="let promo of linePromotion" [header]="promotionLineHeader(promo)" [subheader]="promotionLineSubheader(promo)" [imageOptions]="promotionIcon" class="promo-content">
                        </xm-promotions>
                    </div>
                    <div *ngIf="tradeInDDAPromo?.length">
                        <xm-promotions *ngFor="let promo of tradeInDDAPromo" [header]="promotionTradeInDDAHeader(promo)" [imageOptions]="promotionIcon" class="promo-content">
                        </xm-promotions>
                    </div>
                    <div *ngIf="extendedPromoDollar?.length">
                        <xm-promotions *ngFor="let promo of extendedPromoDollar" [header]="promotionExtendedDollarDDAHeader(promo)" [imageOptions]="promotionIcon" class="promo-content">
                        </xm-promotions>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="features" *ngIf="activePlan && !(accountSummary.level5Customer && plan.isByTheGigShared) && !showPlanSixTabletSection && !lineSummary.isStandaloneWatch">
        <div class="active-plan-feature">
            <h4 class="feature-header">
                {{ featureTitle }}
            </h4>
            <div class="features-content">
                <div *ngFor="let feature of dataFeatures" class="plan-feature">
                    <xm-media-image aria-hidden="true" [imageOptions]="generateFeatureIcon(feature.icon)"
                        class="plan-feature-icon"></xm-media-image>
                    <div class="plan-feature-description">
                        <h4 class="plan-feature-header">{{ feature.header }}</h4>
                        <p class="plan-feature-subheader">{{ feature.subheader }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="shared-data-cta" *ngIf="plan.isByTheGigShared">
            <button id="switch-shared-plan" class="xm-btn-secondary-light promise-btn" [ngClass]="{'disabled': isLLEEnabledMemberOrViewer}" [disabled]="isLLEEnabledMemberOrViewer" [promiseBtn]="planEligibilityPromise"
                (promiseClick)="openSwitchSharedDataModal()"><span>{{ changeSharedDataBtnLabel }}</span></button>
        </div>
        <div class="shared-data-cta" *ngIf="plan.isUnlimited && accountSummary.level4Customer">
            <button id="switch-unlimited-plan" class="xm-btn-secondary-light promise-btn" [ngClass]="{'disabled': isLLEEnabledMemberOrViewer}" [disabled]="isLLEEnabledMemberOrViewer" [promiseBtn]="planEligibilityPromise"
                (promiseClick)="openModal()"><span>{{ cmsDataDetailPageData.manageUnlimitedCta }}</span></button>
            <span class="error" *ngIf="planEligibilityFail">{{ errorText }}</span>
        </div>
        <div class="shared-data-cta" *ngIf="accountSummary.level5Customer && !isPlanSixCbmForLevel5Enabled">
            <button id="switch-shared-plan" class="xm-btn-secondary-light promise-btn" [ngClass]="{'disabled': isLLEEnabledMemberOrViewer}" [disabled]="isLLEEnabledMemberOrViewer" [promiseBtn]="planEligibilityPromise"
                (promiseClick)="openModal()"><span>{{ lineSummary.isUnlBasic ? cmsDataDetailPageData.upgradeToUnlPlusCta : cmsDataDetailPageData.scheduledSwitchLevel5ManageCta}}</span></button>
            <span class="error" *ngIf="planEligibilityFail">{{ errorText }}</span>
        </div>
        <div class="shared-data-cta" *ngIf="isPlanSixCbmForLevel5Enabled">
            <button id="switch-shared-plan" class="xm-btn-secondary-light promise-btn" [ngClass]="{'disabled': isLLEEnabledMemberOrViewer}" [disabled]="isLLEEnabledMemberOrViewer" [promiseBtn]="planEligibilityPromise"
                (promiseClick)="openModal()"><span>{{ switchToCbmLevel5Cta }}</span></button>
            <span class="error" *ngIf="planEligibilityFail">{{ errorText }}</span>
        </div>

    </div>

    <btg-plan-detail-feature-seg-five *ngIf="!activePlan && lineSummary.isScheduledSwitch && !isUnlScheduledSwitch()" [planData]="planData">
        <div class="btn-action">
            <button class="xm-btn-secondary-light promise-btn" [ngClass]="{'disabled': isLLEEnabledMemberOrViewer}" [disabled]="isLLEEnabledMemberOrViewer" [promiseBtn]="planEligibilityPromise"
                (promiseClick)="openModal()"><span>{{ switchPlanLabel }}</span></button>
            <span class="error" *ngIf="planEligibilityFail">{{ errorText }}</span>
        </div>
    </btg-plan-detail-feature-seg-five>
</section>
